import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Spinner } from '~/components';
import EmptyPage from '~/pages/EmptyPage';
import { theme } from '~/styles/theme';
import * as S from '../styles';
import { propTypes, defaultProps } from './propsValidation';

export default function Direct({
  homeTeamShield,
  awayTeamShield,
  columns,
  timelineData,
  title,
  directStats,
  isFetching,
  homeTeam,
  awayTeam,
  eventsFailed,
  directStatsFailed,
  tabletMode,
}) {
  const {
    directStats: { loading },
  } = useSelector(state => state.matches);
  const { data: match } = useSelector(state => state.matches.selectedMatch);
  const styleTab = {
    secondaryColor: match?.competitionId === 1 ? theme.coral : theme.turquoise,
    withBorder: true,
  };
  const [tab, setTab] = useState('local');

  return (
    <S.Container tabletMode={tabletMode} tab={tab}>
      <Spinner isRelative isOpen={loading} />
      {tabletMode && (
        <S.TabsSections
          tabletMode={tabletMode}
          onChange={({ value }) => setTab(value)}
          value={tab}
          localTeam={awayTeam ? homeTeam.nickname : null}
          awayTeam={awayTeam ? awayTeam.nickname : null}
          styleTab={styleTab}
        />
      )}
      {(!tabletMode || (tabletMode && tab === 'local')) && (
        <S.LocalBlock>
          {directStatsFailed && <EmptyPage />}
          {!directStatsFailed && (
            <S.ClubStatsMobile
              title={title}
              columns={columns}
              data={directStats}
              isFetching={isFetching}
              local
            />
          )}
        </S.LocalBlock>
      )}
      <S.MinuteByMinuteBlock
        homeTeamShield={homeTeamShield}
        awayTeamShield={awayTeamShield}
        data={timelineData}
        homeTeam={homeTeam}
        awayTeam={awayTeam}
        eventsFailed={eventsFailed}
        tabletMode={tabletMode}
        competition={match?.competitionId}
      />
      {(!tabletMode || (tabletMode && tab === 'away')) && (
        <S.VisitantBlock>
          {directStatsFailed && <EmptyPage />}
          {!directStatsFailed && (
            <S.ClubStatsMobile
              title={title}
              columns={columns}
              data={directStats}
              isFetching={isFetching}
            />
          )}
        </S.VisitantBlock>
      )}
    </S.Container>
  );
}

Direct.propTypes = propTypes;

Direct.defaultProps = defaultProps;
